import { MapUiTheme } from '../../common';

export const modalTheme = {
  wrapper: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    zIndex: (theme: MapUiTheme) => theme.zIndices.modal,
  },
  overlay: {
    backgroundColor: 'rgba(2, 3, 3, 0.45)',
    zIndex: (theme: MapUiTheme) => theme.zIndices.overlay,
  },
  size: {
    xs: {
      maxWidth: '16rem',
    },
    sm: {
      maxWidth: '22rem',
    },
    md: {
      maxWidth: '28rem',
    },
    lg: {
      maxWidth: '36rem',
    },
    xl: {
      maxWidth: '48rem',
    },
    full: {
      width: 'calc(100vw - 2rem)',
      height: 'calc(100vh - 2rem)',
      marginBottom: '0',
      marginTop: '0',
      margin: '1rem',
    },
  },
  content: {
    width: '100%',
    marginTop: (theme: MapUiTheme) => theme.spacing[16],
    marginBottom: (theme: MapUiTheme) => theme.spacing[16],
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    borderRadius: (theme: MapUiTheme) => theme.spacing[2],
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxShadow: '0 16px 32px 0 rgba(2, 3, 3, 0.16)',
  },
  header: {
    flex: '0 1 0%',
    color: (theme: MapUiTheme) => theme.colors.black,
    fontSize: (theme: MapUiTheme) => theme.fontSize.lg,
    fontWeight: 700,
    paddingTop: (theme: MapUiTheme) => theme.spacing[6],
    paddingBottom: (theme: MapUiTheme) => theme.spacing[4],
    paddingInlineStart: (theme: MapUiTheme) => theme.spacing[6],
    paddingInlineEnd: (theme: MapUiTheme) => theme.spacing[6],
  },
  closeButton: {
    position: 'absolute',
    top: (theme: MapUiTheme) => theme.spacing[4],
    right: (theme: MapUiTheme) => theme.spacing[3],
    paddingLeft: (theme: MapUiTheme) => theme.spacing[2],
    paddingRight: (theme: MapUiTheme) => theme.spacing[2],
    padding: 0,
    width: 30,
    height: 30,
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: '1 1 0%',
    paddingTop: (theme: MapUiTheme) => theme.spacing[2],
    paddingBottom: (theme: MapUiTheme) => theme.spacing[2],
    paddingInlineStart: (theme: MapUiTheme) => theme.spacing[6],
    paddingInlineEnd: (theme: MapUiTheme) => theme.spacing[6],
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: (theme: MapUiTheme) => theme.spacing[4],
    paddingBottom: (theme: MapUiTheme) => theme.spacing[6],
    paddingInlineStart: (theme: MapUiTheme) => theme.spacing[6],
    paddingInlineEnd: (theme: MapUiTheme) => theme.spacing[6],
  },
};
